/* ag-nav-slide (Ansen 2026-10-17, with the collection-filters round): on phones the menu's sections (Executive Desks,
   Conference Tables...) and their lists (by Width, by Finishing Color...) slide open and shut, like the Sort & Filter
   groups, instead of snapping. The theme still decides what opens and closes (header-dropdowns.liquid sets a
   section's display; header.liquid toggles .submenu.show); this script only watches for those changes and animates
   the height. Its own style writes are taken back out of the observer's queue, so it never reacts to itself, and when
   a slide ends the element is handed back exactly as the theme left it.
   Loaded by snippets/header-navigation-dropdowns.liquid. */
(function () {
  'use strict';
  if (window.agNavSlide || !window.MutationObserver) return;
  var PHONE = window.matchMedia('(max-width: 991px)');
  var CALM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var DUR = 280;
  var SEL = '.header_dropdown.mobile_menus > .header_dropdown-nav, .header_dropdown-mobile-nav .submenu';
  var mo = null;

  function shown(el) { return window.getComputedStyle(el).display !== 'none'; }

  function quiet(fn) {                 // write styles without the observer seeing it
    fn();
    if (mo) mo.takeRecords();
  }

  function finish(el) {
    quiet(function () {
      el.style.overflow = el._agOv || '';
      if (!el._agOpening) el.style.display = el._agTheme || '';      // shut: back to the theme's own value
      else if (el._agTheme === '') el.style.display = '';             // reopened list: its class shows it again
      el._agOv = undefined;
      el._agTheme = undefined;
    });
  }

  function slide(el, open) {
    el._agOpening = open;
    if (el._agOv === undefined) el._agOv = el.style.overflow;
    if (!open && el._agTheme === undefined) el._agTheme = el.style.display;   // what the theme just set
    if (el.getAnimations) el.getAnimations().forEach(function (a) { a.onfinish = null; a.cancel(); });
    quiet(function () {
      if (!open) el.style.display = 'block';    // the theme has just hidden it: keep it visible while it slides shut
      el.style.overflow = 'hidden';
    });
    var h = el.scrollHeight;
    var a = el.animate(open
      ? [{ height: '0px', opacity: 0.3 }, { height: h + 'px', opacity: 1 }]
      : [{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
      { duration: DUR, easing: 'ease' });
    a.onfinish = function () { finish(el); if (open) align(el); };
  }

  // Round 6 (Ansen 2026-10-17): when tapping a section below an open one, the old one used to slide shut while the
  // theme was already scrolling the new one to the top, so it landed in the wrong place. A section that shuts in the
  // same tap that opens another now shuts at once (as before this script); only the new one slides open.
  function shutNow(el) {
    if (el.getAnimations) el.getAnimations().forEach(function (a) { a.onfinish = null; a.cancel(); });
    quiet(function () {
      if (el._agOv !== undefined) el.style.overflow = el._agOv;
      if (el._agTheme !== undefined) el.style.display = el._agTheme;
    });
    el._agOv = undefined;
    el._agTheme = undefined;
    el._agOpening = false;
  }

  function scrollBox(el) {             // the theme's own rule for the menu's scroll container
    var n = el && el.parentElement;
    while (n && n !== document.body && n !== document.documentElement) {
      var cs = window.getComputedStyle(n);
      if ((cs.overflowY === 'auto' || cs.overflowY === 'scroll') && n.scrollHeight > n.clientHeight) return n;
      n = n.parentElement;
    }
    return null;
  }

  // After a section or list has slid open, what was tapped sits at the top of the menu (the theme aims for that the
  // moment it opens; this makes sure, now that the heights are final). Matching Sets keeps the theme's own scroll.
  function align(el) {
    var toggle = el.classList.contains('submenu') ? el.previousElementSibling
      : el.parentElement && el.parentElement.querySelector('.header_dropdown-toggle');
    if (!toggle || !shown(el) || el.closest('.matching_sets_dropdown')) return;
    var box = scrollBox(toggle);
    if (!box) return;
    var d = toggle.getBoundingClientRect().top - box.getBoundingClientRect().top;
    if (Math.abs(d) > 4) box.scrollTo({ top: box.scrollTop + d, behavior: 'smooth' });
  }

  // Was it showing before this change? Known if this script has seen the element; otherwise read from the change
  // itself: a list shows by its "show" class, a section by the display the theme writes into its style.
  function before(el, m) {
    if (el._agShown !== undefined) return el._agShown;
    var old = m.oldValue || '';
    if (el.classList.contains('submenu')) return m.attributeName === 'class' ? /(^|\s)show(\s|$)/.test(old) : shown(el);
    return m.attributeName === 'style' ? /display:\s*block/.test(old) : shown(el);
  }

  // The theme builds the phone menu again after the page loads, so the whole page is watched (cheap: only class and
  // style changes, and only the menu's sections and lists are looked at). One tap's changes arrive together: if any
  // section opens, the ones shutting in the same tap shut at once.
  mo = new MutationObserver(function (list) {
    var seen = [], changes = [];
    list.forEach(function (m) {
      var t = m.target;
      if (t.nodeType !== 1 || seen.indexOf(t) >= 0 || !t.matches || !t.matches(SEL)) return;
      seen.push(t);
      var now = shown(t), was = before(t, m);
      t._agShown = now;
      if (now !== was) changes.push({ el: t, open: now });
    });
    if (!changes.length || !PHONE.matches || CALM.matches || !document.documentElement.animate) return;
    var opening = changes.some(function (c) { return c.open; });
    changes.forEach(function (c) {
      if (c.open) slide(c.el, true);
      else if (opening) shutNow(c.el);
      else slide(c.el, false);
    });
  });
  mo.observe(document.documentElement, { subtree: true, attributes: true, attributeOldValue: true, attributeFilter: ['class', 'style'] });
  window.agNavSlide = true;
})();
